import React from "react";
import BulkUploadProgress from "../BulkProcess/BulkUploadProgress";
import theme from "../../theme";
import { getActiveWallets } from "../../utils/wallet";
import { Icon, Tooltip, Typography } from "@plum-xoxo/admin-dsm";
import { app_path } from "config";
import { useHistory } from "react-router-dom";

const Balance = ({ accountReducer, isFirstRewardSent = true }) => {
  const {
    kybStatus = {},
    companyDetails,
    userBalance: {
      userBalance = 0,
      companyBalance = 0,
      currencyCode = "",
      currencySymbol = "",
    } = {},
    platformSettings: {
      lowBalanceThreshold = 0,
      showCompanyBalance = false,
    } = {},
    typeData: { role = 1, walletCompany = 1 },
    clientId,
    moduleAcl,
    typeData: { threshold_amount = 0, used_amount = 0 } = {},
  } = accountReducer;
  const history = useHistory();

  const disableRewardData = kybStatus?.kyb_status !== 2;
  const lowBalance =
    (userBalance || companyBalance) <= lowBalanceThreshold &&
    isFirstRewardSent &&
    role === 1 &&
    !disableRewardData;
  let moduleAclArray = moduleAcl?.map((item) => item?.module_id);
  let activeWallets = getActiveWallets(moduleAclArray, accountReducer, true);

  const getFormattedPrice = (price = 0) =>
    parseFloat(price)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");

  const BalanceDetail = (price) => {
    return (
      <Typography.BodySmall
        color="light"
        shade="c000"
        component="div"
        className="text-right"
      >
        {showCompanyBalance && (
          <>
            Account Wallet Balance: {currencyCode}{" "}
            {activeWallets && getFormattedPrice(activeWallets[0]?.subTitle)}
            <br />
          </>
        )}
        Your Threshold Limit: {currencyCode}{" "}
        {getFormattedPrice(threshold_amount)}
        <br />
        Threshold Used: {currencyCode} {getFormattedPrice(used_amount)}
        <br />
        Threshold Remaining: {currencyCode}{" "}
        {parseFloat(threshold_amount).toFixed(2) -
          parseFloat(used_amount).toFixed(2)}
        <br />
      </Typography.BodySmall>
    );
  };

  const ShowBalance = ({ title = "", amount = 0, className = "" }) => (
    <div className={className}>
      <Typography.BodySmall
        color="dark"
        shade="c200"
        component="div"
        style={{ fontSize: "12px" }}
      >
        {title}
      </Typography.BodySmall>
      <Typography.ButtonText color="dark" shade="c300" className="mt-4">
        {currencyCode || ""}{" "}
        {parseFloat(amount)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
      </Typography.ButtonText>
    </div>
  );

  return (
    <div>
      <div
        className="p-16"
        style={{
          background: theme.palette.light.c000,
          borderRadius: "4px",
        }}
      >
        {role === 100 ? (
          <>
            <ShowBalance
              title="Threshold Remaining"
              amount={threshold_amount - used_amount}
            />
            <hr className="w-100" />
            {showCompanyBalance && (
              <ShowBalance
                title="Wallet Balance"
                amount={activeWallets[0]?.subTitle}
              />
            )}
            <ShowBalance
              title="Threshold Limit"
              amount={threshold_amount}
              className="mt-16"
            />
            <ShowBalance
              title="Threshold Used"
              amount={used_amount}
              className="mt-16"
            />
          </>
        ) : (
          <>
            {activeWallets.map((wallet, index) => (
              <ShowBalance
                key={index}
                title={wallet.title}
                amount={wallet.subTitle}
                className={index !== 0 ? "mt-16" : ""}
              />
            ))}
            {lowBalance && (
              <Typography.BodySmall
                color="red"
                shade="c200"
                className={activeWallets.length === 1 ? "mt-4" : "mt-16"}
              >
                Your balance is low.
              </Typography.BodySmall>
            )}
            <Typography.ButtonText
              color="blue"
              shade="200"
              className="cursor-pointer mt-16"
              onClick={() => {
                if (activeWallets.length === 1) {
                  history.push({
                    pathname: `/${app_path}/payment/`,
                    state: JSON.stringify({
                      amount: "",
                      companyDetails: companyDetails,
                      currencySymbol: currencySymbol,
                      company_recharge: walletCompany === 1 ? 2 : 0,
                      product_type: walletCompany === 1 ? 4 : 1,
                    }),
                  });
                } else {
                  history.push(
                    activeWallets.length > 1
                      ? `/${app_path}/recharge#wallet-balance`
                      : `/${app_path}/payment/`
                  );
                }
              }}
            >
              Add Funds
            </Typography.ButtonText>
          </>
        )}
      </div>
    </div>
  );
};

export default Balance;
